import React, { useState } from 'react';
import { ResolveState } from './types';
interface ResolveButtonProps {
  state: ResolveState;
  onResolve: (state: ResolveState) => void;
}
export function ResolveButton({
  state,
  onResolve
}: ResolveButtonProps) {
  const [open, setOpen] = useState(false);
  if (state === 'resolved') return <button onClick={e => {
    e.stopPropagation();
    onResolve(null);
  }} style={{
    flexShrink: 0,
    width: 26,
    height: 26,
    borderRadius: '50%',
    border: 'none',
    background: '#2D7A6E',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }} data-id="element-140">
        <span style={{
      color: 'white',
      fontSize: 12,
      fontWeight: 800
    }} data-id="element-141">
          ✓
        </span>
      </button>;
  if (state === 'na') return <button onClick={e => {
    e.stopPropagation();
    onResolve(null);
  }} style={{
    flexShrink: 0,
    height: 26,
    borderRadius: 13,
    border: 'none',
    background: '#64748B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px'
  }} data-id="element-142">
        <span style={{
      color: 'white',
      fontSize: 10,
      fontWeight: 800
    }} data-id="element-143">
          N/A
        </span>
      </button>;
  const Opt = ({
    label,
    color,
    val
  }: {
    label: string;
    color: string;
    val: ResolveState;
  }) => <button onClick={() => {
    onResolve(val);
    setOpen(false);
  }} style={{
    width: '100%',
    padding: '9px 12px',
    border: 'none',
    background: 'white',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: 12,
    fontWeight: 600,
    color,
    textAlign: 'left'
  }} onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'} onMouseLeave={e => e.currentTarget.style.background = 'white'} data-id="element-144">
      {label}
    </button>;
  return <div style={{
    position: 'relative',
    flexShrink: 0
  }} onClick={e => e.stopPropagation()} data-id="element-145">
      <button onClick={() => setOpen(!open)} style={{
      width: 26,
      height: 26,
      borderRadius: '50%',
      border: '2px solid #D1D5DB',
      background: 'white',
      cursor: 'pointer'
    }} data-id="element-146" />
      {open && <>
          <div onClick={() => setOpen(false)} style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99
      }} data-id="element-147" />
          <div style={{
        position: 'absolute',
        right: 0,
        top: '100%',
        marginTop: 4,
        background: 'white',
        border: '1px solid #E6E4DF',
        borderRadius: 8,
        boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
        zIndex: 100,
        overflow: 'hidden',
        width: 140
      }} data-id="element-148">
            <Opt label="✓ Resolved" color="#2D7A6E" val="resolved" data-id="element-149" />
            <div style={{
          height: 1,
          background: '#F0EDE8'
        }} data-id="element-150" />
            <Opt label="— N/A" color="#64748B" val="na" data-id="element-151" />
          </div>
        </>}
    </div>;
}